import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';

import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { NgbNavModule } from '@ng-bootstrap/ng-bootstrap';

import { InputTextModule } from 'primeng/inputtext';
import { DropdownModule } from 'primeng/dropdown';
import { CheckboxModule } from 'primeng/checkbox';
import { StudiesSearchFilterComponent } from './studies-search-filter/studies-search-filter.component';
import { CalendarModule } from 'primeng/calendar';
import { LabelFloatDirective } from '@shared/directives/labelFloat.directive';
import { RequiredIfDirective } from '@shared/directives/requiredIf.directive';
import { MinValidatorDirective } from '@shared/directives/min.directive';
import { TreeModule } from 'primeng/tree';
import { TabViewModule } from 'primeng/tabview';
import { PanelModule } from 'primeng/panel';
import { AutoCompleteModule } from 'primeng/autocomplete';
import { ChartModule } from 'primeng/chart';
import { BlockUIModule } from 'primeng/blockui';
import { PaginatorModule } from 'primeng/paginator';
import { TableModule } from 'primeng/table';
import { TreeTableModule } from 'primeng/treetable';
import { MultiSelectModule } from 'primeng/multiselect';
import { InputTextareaModule } from 'primeng/inputtextarea';
import { PickListModule } from 'primeng/picklist';
import { ChipsModule } from 'primeng/chips';
import { ProgressBarModule } from 'primeng/progressbar';
import { ToastModule } from 'primeng/toast';
import { AccordionModule } from 'primeng/accordion';
import { RadioButtonModule } from 'primeng/radiobutton';
import { InputSwitchModule } from 'primeng/inputswitch';
import { ProgressSpinnerModule } from 'primeng/progressspinner';

import { StudyAccessInfoComponent } from './mystudies/study-crud/studyAccessInfo.component';
import { StudyInfoComponent } from './mystudies/study-crud/studyInfo.component';
import { TestedPartyInfoComponent } from './mystudies/study-crud/testedPartyInfo.component';
import { StudyAccessInfoReadOnlyComponent } from './mystudies/study-crud/studyAccessInfo_ReadOnly.component';
import { StudyInfoReadOnlyComponent } from './mystudies/study-crud/studyInfo_ReadOnly.component';
import { TestedPartyInfoReadOnlyComponent } from './mystudies/study-crud/testedPartyInfo_ReadOnly.component';
import { StudyViewModelFactory } from './viewmodel/study.viewmodelfactory';
import { AcceptRejectSelectionComponent } from './shared/accept-reject-selection/accept-reject-selection.component';
import { StudyBlockUIComponent } from './shared/study-block-ui/study-block-ui.component';
import { SpinnerComponent } from './shared/spinner/spinner.component';
import { FileUploadComponent } from '@shared/fileupload/fileupload.component';
import { AutosizeDirective } from '@shared/directives/autosize.directive';
import { ExtractedKeywordListComponent } from './mystudies/analysis/keyword-screening/add-keywords-dialog/extracted-keyword-list/extracted-keyword-list.component';
import { BulkRejectDialogComponent } from '@shared/bulk-reject-dialog/bulk-reject-dialog.component';
import { TooltipPipe } from './tooltip/tooltip.pipe';
import { HyperLinkPipe } from './pipes/hyperlink.pipe';
import { NoDecimalsDirective } from './mystudies/analysis/adjustments/adjustment-shared/no-decimals/no-decimals.directive';
import { WorldRegionsComponent } from '@shared/world-regions/world-regions.component';
import { FilingTypeInfoDialogComponent } from '@shared/filingtype-info-dialog/filingtype-info-dialog.component';

import { TwoDecimalNumberDirective } from '@shared/directives/twodecimalnumber.directive';
import { FormsModule } from '@angular/forms';
import { ButtonModule } from 'primeng/button';
import { StepsModule } from 'primeng/steps';
import { AvatarModule } from 'primeng/avatar';
import { AccessiblePaginatorDirective } from '@shared/directives/accessiblepaginator.directive';
import { CalendarButtonTabindexDirective } from '@shared/directives/calendar-button-tabindex.directive';
import { PCheckboxTabindexDirective } from '@shared/directives/pcheckbox-checkbox-tabindex.directive';
@NgModule({
  imports: [
    CommonModule,
    RouterModule,
    FormsModule,
    NgbModule,
    NgbNavModule,
    ButtonModule,
    StepsModule,
    InputTextModule,
    DropdownModule,
    CheckboxModule,
    CalendarModule,
    TreeModule,
    TabViewModule,
    PanelModule,
    AutoCompleteModule,
    ChartModule,
    BlockUIModule,
    PaginatorModule,
    TableModule,
    TreeTableModule,
    MultiSelectModule,
    InputTextareaModule,
    PickListModule,
    ChipsModule,
    ProgressBarModule,
    ToastModule,
    AccordionModule,
    RadioButtonModule,
    InputSwitchModule,
    AvatarModule,
    ProgressSpinnerModule,
  ],
  declarations: [
    StudiesSearchFilterComponent,
    LabelFloatDirective,
    RequiredIfDirective,
    StudyAccessInfoComponent,
    StudyInfoComponent,
    TestedPartyInfoComponent,
    StudyAccessInfoReadOnlyComponent,
    StudyInfoReadOnlyComponent,
    TestedPartyInfoReadOnlyComponent,
    MinValidatorDirective,
    AcceptRejectSelectionComponent,
    StudyBlockUIComponent,
    SpinnerComponent,
    FileUploadComponent,
    AutosizeDirective,
    ExtractedKeywordListComponent,
    BulkRejectDialogComponent,
    TooltipPipe,
    HyperLinkPipe,
    NoDecimalsDirective,
    WorldRegionsComponent,
    FilingTypeInfoDialogComponent,
    TwoDecimalNumberDirective,
    AccessiblePaginatorDirective,
    CalendarButtonTabindexDirective,
    PCheckboxTabindexDirective,
  ],
  exports: [
    CommonModule,
    FormsModule,
    RouterModule,
    NgbModule,
    NgbNavModule,
    InputTextModule,
    DropdownModule,
    CheckboxModule,
    StudiesSearchFilterComponent,
    CalendarModule,
    LabelFloatDirective,
    RequiredIfDirective,
    TreeModule,
    TabViewModule,
    PanelModule,
    StudyAccessInfoComponent,
    StudyInfoComponent,
    TestedPartyInfoComponent,
    StudyAccessInfoReadOnlyComponent,
    StudyInfoReadOnlyComponent,
    TestedPartyInfoReadOnlyComponent,
    AutoCompleteModule,
    ChartModule,
    BlockUIModule,
    PaginatorModule,
    TableModule,
    TreeTableModule,
    MinValidatorDirective,
    AcceptRejectSelectionComponent,
    MultiSelectModule,
    InputTextareaModule,
    StudyBlockUIComponent,
    SpinnerComponent,
    PickListModule,
    FileUploadComponent,
    AutosizeDirective,
    ChipsModule,
    ExtractedKeywordListComponent,
    BulkRejectDialogComponent,
    TooltipPipe,
    HyperLinkPipe,
    ProgressBarModule,
    ToastModule,
    AccordionModule,
    RadioButtonModule,
    InputSwitchModule,
    NoDecimalsDirective,
    WorldRegionsComponent,
    FilingTypeInfoDialogComponent,
    TwoDecimalNumberDirective,
    AvatarModule,
    ProgressSpinnerModule,
    AccessiblePaginatorDirective,
    CalendarButtonTabindexDirective,
    PCheckboxTabindexDirective
  ],
  providers: [StudyViewModelFactory],
})
export class SharedModule {}
